/** @format */
import { MarketLanguage } from '@mpb-com/feather/enums';

import { SocialChannel } from './types';

export const defaultSocialChannelLinks: Record<SocialChannel, string> = {
    facebook: 'https://www.facebook.com/mpbcom/',
    twitter: 'https://x.com/mpbcom/',
    instagram: 'https://www.instagram.com/mpbcom/',
    youtube: 'https://www.youtube.com/channel/UCET2n5Emx2AHtroKM9l7jDQ',
};

export const socialChannelLinks = {
    [MarketLanguage.FR]: {
        ...defaultSocialChannelLinks,
        facebook: 'https://www.facebook.com/mpbcomFR',
    },
    [MarketLanguage.DE]: {
        ...defaultSocialChannelLinks,
        facebook: 'https://www.facebook.com/mpbcomDE/',
        youtube: 'https://www.youtube.com/channel/UCABRnIBcmdIpbAEty20NfBQ',
    },
};
